<script setup lang="ts">
export interface GrammarWorkflowPanelProps {
  showFooter?: boolean;
}

const props = withDefaults(defineProps<GrammarWorkflowPanelProps>(), {
  showFooter: false,
});

// TODO: magic numbers that should be fixed. Temp fix until we talk to the grammar team about how this should work (NWEB-1503)
const footerHeight = props.showFooter ? 108 : 0;
const panelMaxHeight = `calc(100% - ${footerHeight}px)`;
</script>

<template>
  <div class="h-full min-w-[360px]" v-bind="props">
    <div
      class="w-full h-full shrink overflow-y-auto p-2 bg-light-bg-primary dark:bg-dark-bg-primary"
      :style="`max-height: ${panelMaxHeight};`"
    >
      <slot name="panel-content" />
    </div>
    <template v-if="props.showFooter">
      <div class="shrink-0 h-[68px]">
        <slot name="footer-bottom-buttons" />
      </div>
    </template>
  </div>
</template>
